// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4y-0";
export var eligibilityCardNotEligible = "_4y-1";